import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import CustomerAccessGate from './components/CustomerAccessGate';
import {ExpenseShowcasePage} from './components/ExpenseShowcase';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import CategoryManager from './components/CategoryManager';
import Transactions from './pages/Transactions';
import Recurring from './pages/Recurring';
import Budgets from './pages/Budgets';
import People from './pages/People';
import Reports from './pages/Reports';
import Settings, {HelpPage} from './pages/Settings';
import PersonProfile from './pages/PersonProfile';

function Categories(){const navigate=useNavigate(),location=useLocation();const search=new URLSearchParams(location.search).get('search')||'';return <CategoryManager initialSearch={search} onClose={()=>navigate('/transactions')}/>;}

function App() {
  // The public preview must NEVER initialise AppProvider, AppShell, customer
  // storage, PocketBase, Google OAuth, or any finance routes. It renders only
  // BPA-owned static marketing images on this exact path.
  if(typeof window!=='undefined' && window.location.pathname==='/preview'){
    return <ExpenseShowcasePage/>;
  }
  return (
    <CustomerAccessGate>
    <AppProvider>
      <Router>
        <AppShell>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/recurring" element={<Recurring />} />
            <Route path="/budgets" element={<Budgets />} />
              <Route path="/categories" element={<Categories />} />
            <Route path="/people" element={<People />} />
            <Route path="/people/:id" element={<PersonProfile />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/help" element={<HelpPage />} />
          </Routes>
        </AppShell>
      </Router>
    </AppProvider>
    </CustomerAccessGate>
  );
}

export default App;